import { CompanyType, CompanyActionsList } from "../actions/companyActions";
import { Action } from "../actions/types";

const initialValue: Array<CompanyType> = []

export const CompanyReducer = (state: CompanyType[] =initialValue , action: Action) => {

    switch (action.type) {

        case CompanyActionsList.ADD_COMPANY: {

            return [...state, action.data]
        }

        case CompanyActionsList.EDIT_COMPANY: {

            const updated = [...state].slice()
            const index = updated.findIndex(u => u.id === action.data.id)

            if (index > -1) {
                updated[index] = {
                    ...action.data
                }
            }

            return updated
        }

        case CompanyActionsList.FETCH_COMPANY: {
            return action.data

        }

        case CompanyActionsList.DELETE_COMPANY: {
            return state.filter(i => i.id !== action.data.id)

        }

        case CompanyActionsList.CLEAR_COMPANY: {
            return initialValue

        }

        default: return state
    }

}